/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Records_OwnershipInputs */



/**
* | output |
* | --- |
* | "Ownership" |
*
* @param {Canvas_Domain_Records_OwnershipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_records_ownership = /** @type {((inputs?: Canvas_Domain_Records_OwnershipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Records_OwnershipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besitznachweis")
	return /** @type {LocalizedString} */ ("Ownership")
});